<template>
  <div class="container">
    <step-header />
    <wrap-container class="cascade w50">
      <form-validator>
        <wrap-container>
          <cuit-field
            label="Ingresá el número de CUIT"
            hint="Ingresá el número de CUIT"
            v-model="model.cuit"
            :required="true"
            maxlength="11"
            @click="trackClick('cuit')"
          />
        </wrap-container>
        <wrap-container>
          <input-tip
            description="Es el nombre legal con el que se reconoce a la empresa o comercio."
          >
            <text-input
              label="Ingresá la razón social"
              hint="Nombre de tu empresa"
              v-model="model.razonSocial"
              :required="true"
              @click="trackClick('razonSocial')"
            />
          </input-tip>
        </wrap-container>
        <wrap-container class="recaptcha-holder">
          <vue-recaptcha
            ref="recaptcha"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            @render="onCaptchaRendered"
            badge="inline"
            sitekey="6Lfp-yUUAAAAAFcXnw7yb4EhrGGz0zmF3SZhqViW"
          />
        </wrap-container>
        <sales-button
          class="button"
          label="Continuar"
          :disabled="disabled"
          v-on:click="doLanding"
        />
      </form-validator>
    </wrap-container>
    <wrap-container class="cascade w50">
      <wrap-container class="background">
        <wrap-container class="inner-cascade w30">
          <img
            class="group-2"
            src="@/assets/img/2x/group-2.png"
            alt="beneficios"
          />
        </wrap-container>
        <wrap-container class="inner-cascade w70">
          <wrap-container class="beneficios-container">
            <wrap-container>
              <p
                class="conoce-beneficios"
                v-if="esReferido"
                v-html="
                  config.pasos.paso1.referidoEmprendedor.beneficios.titulo
                "
              />
              <p
                class="conoce-beneficios"
                v-else
                v-html="config.pasos.paso1.beneficios.titulo"
              />

              <offer-group
                item-icon="trapecio"
                :noMargin="true"
                :numeric="false"
                v-if="
                  config.pasos.paso1.beneficios.beneficioItems && !esReferido
                "
              >
                <offer-element
                  v-for="(item, itemIndex) in config.pasos.paso1.beneficios
                    .beneficioItems"
                  :label-light="false"
                  :key="itemIndex"
                  :label="item"
                />
              </offer-group>
            </wrap-container>
            <wrap-container
              v-for="(beneficio, index) in config.pasos.paso1.beneficios.items"
              :key="index"
            >
              <p class="subtitle" v-if="beneficio.titulo">
                <strong v-html="beneficio.titulo" />
              </p>
              <offer-group
                class="offer-group"
                item-icon="rectangle"
                :numeric="false"
                v-if="beneficio.bullets"
              >
                <offer-element
                  v-for="item in beneficio.bullets"
                  :key="item"
                  label-light="true"
                  :label="item"
                />
              </offer-group>
            </wrap-container>
            <div class="benefits-footer"></div>
          </wrap-container>
        </wrap-container>
      </wrap-container>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SalesButton from "@/components/core/SalesButton";
import StepHeader from "@/components/core/StepHeader";
import TextInput from "@/components/core/TextInput";
import InputTip from "@/components/core/custom/InputTip";
import CuitField from "@/components/core/CuitField";
import * as ACTIONS from "@/config/constants/action-types";
import FormValidator from "@/components/core/FormValidator";
import OfferElement from "@/components/core/OfferElement";
import OfferGroup from "@/components/core/OfferGroup";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "Paso1",
  components: {
    FormValidator,
    WrapContainer,
    SalesButton,
    StepHeader,
    TextInput,
    InputTip,
    CuitField,
    OfferGroup,
    OfferElement,
    VueRecaptcha
  },

  data() {
    return {
      model: this.$store.getters.getPaso1(),
      loading: false,
      recaptchaLoaded: false,
      disabled: true
    };
  },

  computed: {
    esReferido() {
      const origin = this.$store.state.origen;
      return (
        process.env.VUE_APP_CAMP === "ofertaDigital" &&
        (origin === "REFEM" || origin === "REFCL")
      );
    }
  },

  methods: {
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(ACTIONS.DO_CLICK_TRACKING, el);
    },
    doLanding() {
      this.$store.dispatch(ACTIONS.DO_PASO1, this.model);
    },
    onCaptchaVerified() {
      this.disabled = false;
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.loading = true;
    },
    onCaptchaRendered() {
      /**
       * Recaptcha cargó correctamente
       */
      this.recaptchaLoaded = true;
    }
  }
};
</script>

<style scoped>
.landing-header {
  margin-bottom: 30px;
}

.boton-inicio {
  max-width: 178px;
}

.group-2 {
  height: 122px;
  object-fit: contain;
}

.landing-form {
  padding-bottom: 60px;
}

.step {
  font-size: 11px;
  line-height: 1em;
  text-transform: uppercase;
  color: #666666;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 0;
}

.body {
  margin: 0;
}

.background {
  width: 90%;
  height: 110%;
  border-radius: 1px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
}

.group-2 {
  width: 100%;
  margin-top: 17px;
}

.conoce-beneficios {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: #121212;
}

.subtitle {
  margin-bottom: 0;
}

.inner-cascade {
  display: inline-block;
  vertical-align: top;
}

.beneficios-container {
  margin-left: 5%;
  width: 90%;
}

.w30 {
  width: 30%;
}

.w70 {
  width: 70%;
}

.benefits-footer {
  display: block;
  height: 1px;
}

.recaptcha-holder {
  margin-top: 40px;
  margin-bottom: 40px;
}

@media screen and (max-width: 600px) {
  .circle-icons-container .grid-container {
    margin-bottom: 30px;
  }

  .w70 {
    width: 100%;
  }

  .w30 {
    width: 100%;
  }

  .inner-cascade {
    display: block;
  }

  .background {
    width: 100%;
    margin-top: 20px;
  }

  .form {
    margin-right: 0px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .inner-cascade {
    display: block;
    width: 100% !important;
  }

  form {
    margin-right: 33px;
  }
}

@media screen and (min-width: 1025px) {
  form {
    margin-right: 33px;
  }
}
</style>
